import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { FiMenu, FiX } from 'react-icons/fi';
import logoName from '../images/auravit_logo.png';

export default function AppHeader() {
  const navigate = useNavigate();
  const [activeSection, setActiveSection] = useState('hero');
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  // Smooth scroll to section
  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setActiveSection(sectionId);
      setIsMobileMenuOpen(false); // Close mobile menu after navigation
    }
  };

  // Track which section is currently in view
  useEffect(() => {
    const handleScroll = () => {
      const sections = ['hero', 'problem', 'features', 'mission', 'security'];
      const scrollPosition = window.scrollY + 200;

      for (const section of sections) {
        const element = document.getElementById(section);
        if (element) {
          const { offsetTop, offsetHeight } = element;
          if (scrollPosition >= offsetTop && scrollPosition < offsetTop + offsetHeight) {
            setActiveSection(section);
            break;
          }
        }
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navItems = [
    { id: 'hero', label: 'Home' },
    { id: 'problem', label: 'Challenge' },
    { id: 'features', label: 'Features' },
    { id: 'mission', label: 'Mission' },
    { id: 'security', label: 'Security' }
  ];

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  return (
    <>
      <div className="lp-navbar">
        {/* Logo */}
        <div className="lp-logo">
          <img
            src={logoName}
            alt="AURAVIT"
            className="logo-image"
            width="190"
            height="36"
          />
        </div>

        {/* Desktop Navigation */}
        <div className="lp-section-nav-wrapper">
          {navItems.map((item) => (
            <button
              key={item.id}
              className={`lp-nav-btn ${activeSection === item.id ? 'active' : ''}`}
              onClick={() => scrollToSection(item.id)}
            >
              {item.label}
            </button>
          ))}
        </div>

        {/* Right Actions */}
        <div className="lp-nav-actions">
          {/* Mobile Menu Button */}
          <button
            className="lp-mobile-menu-toggle"
            onClick={toggleMobileMenu}
            aria-label="Open Menu"
          >
            <FiMenu />
          </button>

          {/* Sign In Button */}
          <button
            className="lp-btn lp-btn-outline"
            onClick={() => navigate('/login')}
          >
            Sign In
          </button>

          {/* Get Started Button */}
          <button
            className="lp-btn lp-btn-primary"
            onClick={() => navigate('/terms-and-conditions')}
          >
            Get Started
          </button>
        </div>
      </div>

      {/* Mobile Menu Overlay */}
      <div
        className={`lp-mobile-menu-overlay ${isMobileMenuOpen ? 'visible' : ''}`}
        onClick={() => setIsMobileMenuOpen(false)}
      ></div>

      {/* Mobile Menu Drawer */}
      <div className={`lp-mobile-menu-drawer ${isMobileMenuOpen ? 'open' : ''}`}>
        <div className="lp-mobile-menu-header">
          <div className="lp-mobile-menu-logo">
            <img
              src={logoName}
              alt="AURAVIT"
              className="logo-image"
              width="190"
              height="36"
            />
          </div>
          <button
            className="lp-mobile-menu-close"
            onClick={() => setIsMobileMenuOpen(false)}
            aria-label="Close Menu"
          >
            <FiX />
          </button>
        </div>

        <nav className="lp-mobile-menu-nav">
          {navItems.map((item) => (
            <button
              key={item.id}
              className={`lp-mobile-menu-link ${activeSection === item.id ? 'active' : ''}`}
              onClick={() => scrollToSection(item.id)}
            >
              {item.label}
            </button>
          ))}
        </nav>
      </div>
    </>
  );
}
